export interface DeviceProfile {
  isKindleLite: boolean;
}

/**
 * Detect Kindle-era browsers (Kindle/Web Explorer/Silk) and expose a single
 * low-effects profile for constrained rendering engines.
 */
export function detectDeviceProfile(): DeviceProfile {
  if (typeof window === 'undefined') {
    return { isKindleLite: false };
  }

  const params = new URLSearchParams(window.location.search);
  const forceOn = params.get('kindleLite') === '1';
  const forceOff = params.get('kindleLite') === '0';

  if (forceOn) return { isKindleLite: true };
  if (forceOff) return { isKindleLite: false };

  const ua = navigator.userAgent || '';
  const lowerUA = ua.toLowerCase();

  // Common Kindle/Web Explorer signatures.
  const isKindleUA =
    /kindle|silk|kf[a-z0-9]+|kftt|kfot|kfjwa|kfsowi|kfaswi/i.test(ua) ||
    lowerUA.includes('amazonwebappplatform');

  return {
    isKindleLite: isKindleUA,
  };
}
